module.exports = __webpack_public_path__ + "img/qr_code.74c75bf0.png";